import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { CreateReviewType } from './model';

export const useSubmitReview = (): UseMutationResult<CreateReviewType, unknown, CreateReviewType> =>
    useBffPostMutation<CreateReviewType, CreateReviewType>(
        '/turn-to/reviews',
        [],
        [BffQueryKey.TURN_TO_DATA],
    );
